// httpConfig.interceptor.ts
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular';

import { StorageService } from '../services/storage/storage.service';
import { AuthenticationService } from '../services/authentication/authentication.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  API_TOKEN = '';

  constructor(public toastController: ToastController, private storageService: StorageService,
              private authenticationService: AuthenticationService) {
    // TODO: IMPROVE THE CACHED API TOKEN INITIAL RETRIEVAL SPEED
    this.storageService.getObject('user-info').then(res => {
      if (res) {
        // console.log(res.token);
        this.API_TOKEN = res.token;
      }
    });
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // Authentication by setting header with token value
    if (this.API_TOKEN === '') {
      this.storageService.getObject('user-info').then(res => {
      if (res) {
        // console.log(res);
        this.API_TOKEN = res.token;
        // clone request with latest retrieved key
        request = request.clone({
        setHeaders: {
          Authorization: this.API_TOKEN
        }
      });
      }
    });
    } else {
      // console.log(this.API_TOKEN);
      request = request.clone({
        setHeaders: {
          Authorization: this.API_TOKEN
        }
      });
    }

    if (!request.headers.has('Content-Type')) {
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json'
        }
      });
    }

    request = request.clone({
      headers: request.headers.set('Accept', 'application/json')
    });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // console.log('event--->>>', event);
        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        console.error(error.error);
        if (error.status === 401) {
          // this.presentToast('Unauthorized request !!');
          this.authenticationService.logout();
          if (error.error.success === false) {
            this.presentToast('Authentication failed');
          } else {
            // this.router.navigate(['login']);
          }
        } else if (error.status === 400) {
          if (error.error.non_field_errors) {
            this.presentToast(error.error.non_field_errors[0]);
          } else {
            const errorMessages = 'Enter Username: ' + error.error.username[0] + '\n ' +
                                  'Enter Password: ' + error.error.password[0] ;
            this.presentToast(errorMessages);
          }
        } else if (error.status === 404) {
            this.presentToast('Endpoint cannot be reached, please check your server settings');
        } else if (error.status === 500) {
            this.presentToast('Server Error, please submit valid data or contact server Admin');
        } else {
          this.presentToast('Error : ' + error.status);
        }
        return throwError(error);
      }));
  }

  async presentToast(msg) {
    const toast = await this.toastController.create({
      message: msg,
      duration: 2000,
      position: 'middle',
      color: 'danger'
    });
    toast.present();
  }


}
